import { AbstractService } from '@uniqoders/sdk';

export default class ReviewService extends AbstractService {
  /**
   * Retrieve paginated CMS reviews for an agency
   */
  public listCmsReviews(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/reviews', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS review
   */
  public getCmsReview(agency: string, cmsReviewId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/reviews/{cmsReviewId}', { agency, cmsReviewId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS review
   */
  public createCmsReview(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/reviews', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS review
   */
  public updateCmsReview(agency: string, cmsReviewId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/reviews/{cmsReviewId}', { agency, cmsReviewId }),
      data,
    });
  }

  /**
   * Delete a CMS review
   */
  public deleteCmsReview(agency: string, cmsReviewId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/reviews/{cmsReviewId}', { agency, cmsReviewId }),
    });
  }

  /**
   * Update review status (approve/reject)
   */
  public updateCmsReviewStatus(agency: string, cmsReviewId: number, status: 'pending' | 'approved' | 'rejected'): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/reviews/{cmsReviewId}/status', { agency, cmsReviewId }),
      data: { status },
    });
  }
}

